import styled from 'styled-components';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import variables from '../../../../styles/variables';
import Image from '../../../UI/Image/Image';

interface InventoryProps {
  $renderInventory?: boolean;
}

export const CarrierOfferForPhone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  width: 100%;
  min-height: 60px;
  padding: 20px;
  margin: 0 0 16px 0;
  border-radius: 20px;
  border: 1px solid var(--grey-2-d-9-d-9-d-9, #D9D9D9);
  background-color: ${variables.colorWhite};
  font-size: 14px;
`;

export const Legend = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--grey-2-d-9-d-9-d-9, #D9D9D9);
`;

export const TelecomProvider = styled.div`
  display: flex;
  height: 16px;
`;

export const TelecomLogo = styled(Image)`
  height: 100%;
  width: auto;
`;

export const BonusOffer = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  position: relative;

  span {
    padding-right: 20px;
    padding-left: 5px;
    position:relative;
    color: ${variables.colorRed};
    font-size: 14px;
    font-weight: 600;

    &:after {
      position: absolute;
      right: 6px;
      top: 2px;
      width: 12.323px;
      height: 8.624px;
      content: '';
      background-image: url('/pts.svg');
      background-size: 12.323px;
      background-repeat: no-repeat;
    }
  }
`;

export const AccordionWrapper = styled(Accordion)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AccordionDualPricing = styled(AccordionItem)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid var(--grey-2-d-9-d-9-d-9, #D9D9D9);
`;

export const AccordionHeading = styled(AccordionItemHeading)`
  width: 100%;
`;

export const AccordionButton = styled(AccordionItemButton)`
  width: 100%;
  cursor: pointer;
  /* When content is expanded */
  &[aria-expanded='true'] .arrowButton {
    border-color: ${variables.colorRed};
    transform: rotate(-135deg);
    margin-top: 4px;
  }
`;

export const Preview = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0;
`;

export const PreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  p {
    display: flex;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 0;

    strong {
      font-size: 18px;
      font-weight: 600;
      line-height: 18px;
    }

    b {
      font-weight: 600;
    }
  }
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 0;
`;

export const DetailLabel = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 0;
  padding-right: 5px;

  strong {
    font-size: 18px;
    font-weight: 600;
    line-height: 18px;
  }
`;

export const PriceLarge = styled.span`
  font-size: 18px;
  font-weight: 600;
  line-height: 18px;
  margin-bottom: 0;

  .small {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const Price = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  margin-bottom: 0;
`;

export const ButtonGraphicWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: end;

  p {
    font-size: 10px;
    margin-bottom: 0;
    padding-right:5px;
  }
`;

export const ButtonGraphic = styled.div`
  width: 8px;
  height: 8px;
  border-right: solid 2px ${variables.colorRed};
  border-bottom: solid 2px ${variables.colorRed};
  transform: rotate(45deg);
  margin-top: -6px;
`;

export const InventoryWrapper = styled.div<InventoryProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: ${({ $renderInventory }) => ($renderInventory ? '8px 0 0' : '8px 0 0')};
`;

export const ExpandedTierDetails = styled(AccordionItemPanel)`
  width: 100%;
  padding: 0 0 8px;
`;

export const Disclaimer = styled.span`
  p {
    font-size: 12px;
    line-height: 18px;
    width: 100%;
    color: ${variables.colorBlack};
    margin-bottom: 0;

    strong {
      font-weight: 600;
    }
  }
`;
